import { useExecuteQueryPreviewMutation } from "@/services/it/updates/query-update";
import { Button } from "components/ui/button";
import { Textarea } from "components/ui/textarea";
import React, { useEffect, useState } from "react";
import { MESSAGES } from "../../utils/messages";
import { QueryResponseData } from "@/@types/query-response";
import { toast } from "components/ui/use-toast";
import ErrorTerminal from "./error-terminal";
import { FaPlay } from "react-icons/fa";
import { DataPreviewModal } from "./modal/data-preview-modal";
import { SelectResultsDialog } from "./select/result-dialog";
import SelectConnections from "./select/select-connections";

const QueryRequest = () => {
  const [query, setQuery] = useState<string>("");
  const [modalData, setModalData] = useState<QueryResponseData | null>(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDialogOpen, setDialogOpen] = useState(!!modalData);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [selectConnectionId, setSelectConnectionId] = useState<string | null>(
    null
  );

  const [executeQueryPreview, { isLoading }] = useExecuteQueryPreviewMutation();

  console.log(selectConnectionId);

  const handleQueryChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setQuery(event.target.value);
  };

  const connectionId = Number(selectConnectionId || 1);

  const handlePreviewSubmit = async () => {
    try {
      const result = await executeQueryPreview({
        query,
        connectionId,
      }).unwrap();

      if (
        result === `Comandos do tipo 'TRUNCATE' ou 'DROP' não são permitidos.`
      ) {
        toast(MESSAGES.QUERY_ERROR.ERROR);
        return;
      }

      console.log(result.length === undefined);
      if (
        result ===
        `Comandos do tipo 'UPDATE' ou 'DELETE' sem 'WHERE' não são permitidos.`
      ) {
        toast(MESSAGES.NO_WHERE.ERROR);
        return;
      }

      if (!result.result_before && !result) {
        alert("Essa query não modificou nenhum dado, revise-a!");
        setQuery("");
        return;
      }

      setModalData(result);
      setModalOpen(true);
      setErrorMessage("");
      toast(MESSAGES.CREATE.SUCCESS);
    } catch (error: any) {
      if (error?.status === 500) {
        setErrorMessage(error?.data?.messages[0]);
      } else {
        console.error("Algo não saiu como esperado!", error);
        setErrorMessage("Erro inesperado ao executar a query.");
      }
      console.log(error);
      toast(MESSAGES.CREATE.ERROR);
    }
  };

  useEffect(() => {
    if (modalData?.type === "SELECT") {
      setDialogOpen(true);
    }
  }, [modalData]);

  return (
    <div className="w-full flex flex-col gap-3 justify-between md:h-[500px]">
      <div className="w-full flex flex-col gap-3">
        <div className="flex justify-between items-center">
          <span className="text-xl lg:text-3xl font-semibold">
            Requisição de Query
          </span>
        </div>
        <Textarea
          className="font-consolas min-h-[300px] w-full bg-[#fff] border-black/20 border rounded-lg px-5 py-2 focus:outline-none focus:border-2 focus:border-[#000000]/40"
          name=""
          disabled={isLoading}
          value={query}
          onChange={handleQueryChange}
          placeholder={`UPDATE TABELA 
SET CAMPO1 = 100
WHERE CAMPO1 = 1000;`}
          id=""
        ></Textarea>
        <div className="flex justify-center gap-2 md:justify-between items-center w-full">
          <div>
            <SelectConnections onValueChange={setSelectConnectionId} />
          </div>
          <div className="flex gap-2 items-center">
            {modalData?.type === "SELECT" ? (
              <div className="w-full">
                <SelectResultsDialog
                  query={query}
                  modalData={modalData}
                  isDialogOpen={isDialogOpen}
                  setDialogOpen={setDialogOpen}
                />
              </div>
            ) : (
              modalData &&
              isModalOpen && (
                <DataPreviewModal
                  query={query}
                  connectionId={connectionId}
                  data={modalData}
                  onClose={() => setModalOpen(false)}
                />
              )
            )}
            <Button
              onClick={handlePreviewSubmit}
              disabled={isLoading || query.length === 0 || !connectionId}
              className="bg-black text-white rounded-md font-[550] text-sm p-2 px-4 flex items-center gap-2 hover:bg-black/80 transition-all ease-in-out duration-300"
            >
              <FaPlay />
              {isLoading ? "Carregando..." : "Executar Query"}
            </Button>
          </div>
        </div>
      </div>
      <div>
        <ErrorTerminal error={errorMessage || ""} />
      </div>
    </div>
  );
};

export default QueryRequest;
